var Gift;

Gift = require('../../../gift_button/frontend/gift');

if (window.MultiOptionModal == null) {
  window.MultiOptionModal = {};
}

MultiOptionModal.init = function(payload, done) {
  var openMultiOptionModal;
  if (!(payload != null ? payload.buyButton.multiOptionEnabled : void 0)) {
    return done();
  }
  openMultiOptionModal = function(e) {
    var $modal, $otherTooltip, $tooltipTrigger, firstAvailableOption, modalSelector;
    modalSelector = BuyButton.view.offersClicked ? '#offer-options' : '#options';
    $modal = $(modalSelector);
    if (!$modal.length) {
      return;
    }
    if ($modal.hasClass('tooltip')) {
      $otherTooltip = modalSelector === '#options' ? $('#offer-options') : $('#options');
      if ($otherTooltip.is(':visible')) {
        $otherTooltip.find('.tooltip-close').click();
      }
      $tooltipTrigger = (e != null ? e.delegateTarget : void 0) ? $(e.delegateTarget) : BuyButton.view.offersClicked ? $('.offer-buy-button') : Gift.cookieCreated ? $('.gift-button') : $('.buy-button');
      $tooltipTrigger.attr({
        'data-position': 'bottom',
        'data-tooltip-id': modalSelector.slice(1),
        'data-trigger-event': 'js-trigger'
      });
      $tooltipTrigger.find('.tooltip-target').attr('data-position', 'bottom');
      GIG.Tooltip.helpers.tooltip.apply($tooltipTrigger[0], [
        {
          preventDefault: function() {}
        }
      ]);
    } else {
      if ($modal.hasClass('show-modal')) {
        return;
      }
      if ($(".header-row-sticky").is(":visible") && !payload.buyButton.multiOptionInline) {
        return;
      }
      if (!BuyButton.view.$multiOptions.filter('.selected').length) {
        firstAvailableOption = BuyButton.view.$multiOptions.not(":disabled")[0];
        BuyButton.view.updateMultiOptionBreakoutButton({
          currentTarget: firstAvailableOption
        });
      }
      GIG.Modal.open({
        el: $modal
      });
    }
    return {
      stopTheBus: true
    };
  };
  if (payload.buyButton.multiOptionInline) {
    BuyButton.eventBus.board('view_options_clicked', openMultiOptionModal);
  } else {
    BuyButton.eventBus.board('buy_button_clicked', openMultiOptionModal)(998);
  }
  return $(function() {
    var $tooltipCloser, $triggers;
    $triggers = $(".show-multi-option-modal");
    $triggers.click(openMultiOptionModal);
    $tooltipCloser = $('.tooltip-close.icon-x');
    if ($tooltipCloser.length > 0) {
      $tooltipCloser.off('click');
      $tooltipCloser.on('click', GIG.Tooltip.helpers.hideTooltip);
    }
    GIG.Modal.onClose(Gift.removeCookie, 'options');
    GIG.Modal.onClose(Gift.removeCookie, 'offer-options');
    $('#options, #offer-options').on('click', '.tooltip-close', Gift.removeCookie);
    return done();
  });
};

module.exports = MultiOptionModal;

//# sourceMappingURL=data:application/json;base64,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
